import { apiFetch } from '../api-client';

export interface DashboardOverview {
  alerts: {
    pendingApprovals: number;
    overduePayments: Array<{ customer: string; amount: number; overdueDays: number }>;
    pendingPayrolls: number;
  };
  kpi: {
    revenue: number;
    cost: number;
    profit: number;
    salary: number;
  };
  activity: Array<{
    time: string;
    actor: string;
    action: string;
    code: string;
    meta: string;
  }>;
}

export interface MonthlyTrend {
  year: number;
  months: Array<{ month: number; label: string; revenue: number; cost: number }>;
}

export interface CostBreakdown {
  year: number;
  month?: number;
  total: number;
  items: Array<{ label: string; value: number; pct: number; color: string }>;
}

export const dashboardApi = {
  overview: () => apiFetch<DashboardOverview>('/api/dashboard/overview'),
  monthlyTrend: (year?: number) => apiFetch<MonthlyTrend>(
    year ? `/api/dashboard/monthly-trend?year=${year}` : '/api/dashboard/monthly-trend',
  ),
  costBreakdown: (year?: number, month?: number) => {
    const p = new URLSearchParams();
    if (year) p.set('year', String(year));
    if (month) p.set('month', String(month));
    const q = p.toString() ? `?${p.toString()}` : '';
    return apiFetch<CostBreakdown>(`/api/dashboard/cost-breakdown${q}`);
  },
};
